import { PageLocatorMap } from '../types/PageLocatorMap';

export const dashboardGaragePage = {
  alert: {
    error: 'dashboard-garage-page.alert.error',
  },
  footer: {
    root: 'dashboard-garage-page.footer.root',
  },
  header: {
    drawerButton: 'dashboard-garage-page.header.drawer-button',
    root: 'dashboard-garage-page.header.root',
  },
  main: {
    cardList: 'dashboard-garage-page.main.card-list',
    emptyNewApplicationButton:
      'dashboard-garage-page.main.empty-new-application-button',
    getCardListItem: (index: number): string =>
      `dashboard-garage-page.main.card-list-item-${index + 1}`,
    h1: 'dashboard-garage-page.main.heading1',
    h2: 'dashboard-garage-page.main.heading2',
    h3: 'dashboard-garage-page.main.heading3',
    newApplicationButton: 'dashboard-garage-page.main.new-application-button',
    root: 'dashboard-garage-page.main.root',
  },
} as const satisfies PageLocatorMap;
